import { COOKIE_DAYS_TO_EXPIRE } from '@/constants/config'

/**
 * Unified cookie configuration for the entire application.
 *
 * IMPORTANT: These settings MUST be identical across:
 * - Proxy (src/proxy.ts)
 * - Server-side Amplify (src/lib/auth/server/amplify.server.ts)
 * - Client-side Amplify (src/components/providers/amplify/amplify.tsx)
 * - Edge utilities (src/lib/auth/middleware/utils.edge.ts)
 *
 * Why each setting matters:
 * - sameSite: 'none' - Required for cross-origin iframe embedding
 * - secure: true - Required when sameSite is 'none'
 * - httpOnly: false - Amplify needs client-side JS access to tokens
 * - partitioned: false - CRITICAL: Must be consistent everywhere
 *   (partitioned cookies are isolated from non-partitioned ones)
 */
export const COOKIE_CONFIG = {
  sameSite: 'none' as const,
  secure: true,
  httpOnly: false,
  // IMPORTANT: Do NOT use partitioned: true unless ALL cookie setters use it
  // Mixing partitioned and non-partitioned cookies causes isolation issues
} as const

/**
 * Get the max age in seconds for cookies
 */
export function getCookieMaxAge(): number {
  return COOKIE_DAYS_TO_EXPIRE * 24 * 60 * 60
}

/**
 * Full cookie config with maxAge for server-side use
 */
export function getFullCookieConfig() {
  return {
    ...COOKIE_CONFIG,
    maxAge: getCookieMaxAge(),
  }
}
